module.exports = {
	"signout": "Sign Out",
	"remember": "Remember me",
	"rememberDevice": "Trust this device",
	"rememberDevice.timebased": "Do not challenge me on this device for the next {0}",
	"rememberDevice.devicebased": "Do not challenge me on this device again",
	"autoPush": "Send push automatically",
	"unlockaccount": "Unlock account?",
	"needhelp": "Need help signing in?",
	"goback": "Back to Sign In",
	"forgotpassword": "Forgot password?",
	"help": "Help",
	"retry": "Retry",
	"minutes.oneMinute": "minute",
	"minutes": "{0} minutes",
	"hours": "{0} hours",
	"days": "{0} days",
	"error.config": "There was a configuration error",
	"error.required.authParams": "Missing parameters for the configured authentication scheme - \"OAUTH2\"",
	"error.required.baseUrl": "\"baseUrl\" is a required widget parameter",
	"error.required.success": "A success handler is required",
	"error.required.el": "\"el\" is a required widget parameter",
	"error.unsupported.browser": "Unsupported browser",
	"error.unsupported.cors": "Unsupported browser - missing CORS support",
	"error.unsupported.localStorage": "Unsupported browser - missing localStorage support",
	"error.enabled.cors": "There was an error sending the request - have you enabled CORS?",
	"error.expired.session": "Your session has expired. Please try to log in again.",
	"error.auth.lockedOut": "Your account is locked. Please contact your administrator.",
	"error.oauth.idToken": "There was a problem generating the id_token for the user. Please try again.",
	"error.network.connection": "Unable to connect to the server. Please check your network connection.",
	"error.username.required": "Please enter a username",
	"error.password.required": "Please enter a password",
	"errors.E0000004": "Sign in failed!",
	"errors.E0000069": "Your account was locked due to excessive MFA attempts.",
	"errors.E0000047": "You exceeded the maximum number of requests. Try again in a while.",
	"errors.E0000001": "Api validation failed: {0}",
	"errors.E0000002": "The request was not valid: {0}",
	"errors.E0000003": "The request body was not well-formed.",
	"errors.E0000005": "Invalid session",
	"errors.E0000006": "You do not have permission to perform the requested action",
	"errors.E0000007": "Not found: {0}",
	"errors.E0000008": "The requested path was not found",
	"errors.E0000009": "Internal Server Error",
	"errors.E0000010": "Service is in read only mode",
	"errors.E0000011": "Invalid token provided",
	"errors.E0000012": "Unsupported media type",
	"errors.E0000013": "Invalid client app id",
	"errors.E0000015": "You do not have permission to access the feature you are requesting",
	"errors.E0000016": "Activation failed because the user is already active",
	"errors.E0000017": "Password reset failed",
	"errors.E0000018": "Bad request.  Accept and/or Content-Type headers are likely not set.",
	"errors.E0000019": "Bad request.  Accept and/or Content-Type headers likely do not match supported values.",
	"errors.E0000020": "Bad request.",
	"errors.E0000021": "Bad request.  Accept and/or Content-Type headers likely do not match supported values.",
	"errors.E0000022": "The endpoint does not support the provided HTTP method",
	"errors.E0000023": "Operation failed because user profile is mastered under another system",
	"errors.E0000024": "Bad request.  This operation on app metadata is not yet supported.",
	"errors.E0000025": "App version assignment failed.",
	"errors.E0000026": "This endpoint has been deprecated.",
	"errors.E0000027": "Group push bad request : {0}",
	"errors.E0000028": "The request is missing a required parameter.",
	"errors.E0000029": "Invalid paging request.",
	"errors.E0000030": "Bad request. Invalid date. Dates must be of the form yyyy-MM-dd''T''HH:mm:ss.SSSZZ, e.g. 2013-01-01T12:00:00.000-07:00.",
	"errors.E0000031": "Invalid search criteria.",
	"errors.E0000032": "Unlock is not allowed for this user.",
	"errors.E0000033": "Bad request. Can't specify a search query and filter in the same request.",
	"errors.E0000034": "Forgot password not allowed on specified user.",
	"errors.E0000035": "Change password not allowed on specified user.",
	"errors.E0000036": "Change recovery question not allowed on specified user.",
	"errors.E0000037": "Type mismatch exception.",
	"errors.E0000038": "This operation is not allowed in the user''s current status.",
	"errors.E0000039": "Operation on application settings failed.",
	"errors.E0000040": "Application label must not be the same as an existing application label.",
	"errors.E0000041": "Credentials should not be set on this resource based on the scheme.",
	"errors.E0000042": "Setting the error page redirect URL failed.",
	"errors.E0000043": "Self service application assignment is not enabled.",
	"errors.E0000044": "Self service application assignment is not supported.",
	"errors.E0000045": "Field mapping bad request.",
	"errors.E0000046": "Deactivate application for user forbidden.",
	"errors.E0000048": "Entity not found exception.",
	"errors.E0000049": "Invalid SCIM data from SCIM implementation.",
	"errors.E0000050": "Invalid SCIM data from client.",
	"errors.E0000051": "No response from SCIM implementation.",
	"errors.E0000052": "Endpoint not implemented.",
	"errors.E0000053": "Invalid SCIM filter.",
	"errors.E0000054": "Invalid pagination properties.",
	"errors.E0000055": "Duplicate group.",
	"errors.E0000056": "Delete application forbidden.",
	"errors.E0000057": "Access to this application is denied due to a policy.",
	"errors.E0000058": "Access to this application requires MFA: {0}",
	"errors.E0000059": "The connector configuration could not be tested. Make sure that the URL, Authentication Parameters are correct and that there is an implementation available at the URL provided.",
	"errors.E0000060": "Unsupported operation.",
	"errors.E0000061": "Tab error: {0}",
	"errors.E0000062": "The specified user is already assigned to the application.",
	"errors.E0000063": "Invalid combination of parameters specified.",
	"errors.E0000064": "Password is expired and must be changed.",
	"errors.E0000065": "Internal error processing app metadata.",
	"errors.E0000066": "APNS is not configured, contact your admin",
	"errors.E0000067": "Factors Service Error.",
	"errors.E0000070": "Waiting for ACK",
	"errors.E0000071": "Unsupported OS Version: {0}",
	"errors.E0000072": "MIM policy settings have disallowed enrollment for this user",
	"errors.E0000073": "User rejected authentication",
	"errors.E0000074": "Factor Service Error",
	"errors.E0000075": "Cannot modify the {0} attribute because it has a field mapping and profile push is enabled.",
	"errors.E0000076": "Cannot modify the app user because it is mastered by an external app.",
	"errors.E0000077": "Cannot modify the {0} attribute because it is read-only.",
	"errors.E0000078": "Cannot modify the {0} attribute because it is immutable.",
	"errors.E0000079": "This operation is not allowed in the current authentication state.",
	"errors.E0000081": "Cannot modify the {0} attribute because it is a reserved attribute for this application.",
	"errors.E0000082": "Each code can only be used once. Please wait for a new code and try again.",
	"errors.E0000083": "PassCode is valid but exceeded time window.",
	"errors.E0000084": "App evaluation error.",
	"errors.E0000085": "You do not have permission to access your account at this time.",
	"errors.E0000086": "This policy cannot be activated at this time.",
	"errors.E0000087": "The recovery question answer did not match our records.",
	"errors.E0000090": "The role specified is already assigned to the user.",
	"errors.E0000091": "The provided role type was not the same as required role type.",
	"errors.E0000092": "Access to this application requires re-authentication: {0}",
	"errors.E0000093": "Target count limit exceeded",
	"errors.E0000094": "The provided filter is unsupported.",
	"errors.E0000095": "Recovery not allowed for unknown user.",
	"errors.E0000096": "This certificate has already been uploaded with kid={0}.",
	"errors.E0000097": "There is no verified phone number on file.",
	"errors.E0000098": "This phone number is invalid.",
	"errors.E0000099": "Only numbers located in US and Canada are allowed.  Contact your administrator if this is a problem.",
	"errors.E0000100": "Unable to perform search query.",
	"errors.E0000101": "Upload failed because of a problem with your ipa file, {0}",
	"errors.E0000102": "YubiKey cannot be deleted while assigned to an user. Please deactivate YubiKey using reset MFA and try again",
	"errors.E0000103": "Action on device already in queue or in progress",
	"errors.E0000104": "Device is already locked and cannot be locked again",
	"errors.E0000105": "You have accessed an account recovery link that has expired or been previously used.",
	"errors.E0000106": "Wait for token to change, then enter the new tokencode.",
	"errors.E0000107": "The entity is not in the expected state for the requested transition.",
	"errors.E0000109": "An SMS message was recently sent. Please wait 30 seconds before trying again.",
	"errors.E0000110": "You have accessed a link that has expired or has been previously used.",
	"errors.E0000111": "Cannot modify the {0} object because it is read-only.",
	"errors.E0000112": "Cannot update this user because they are still being activated. Please try again in a few minutes.",
	"errors.E0000113": "{0}.",
	"errors.E0000114": "A user with this login already exists in the current organization.",
	"errors.E0000115": "Upload failed, {0}",
	"errors.E0000116": "{0}",
	"errors.E0000119": "Your account is locked. Please contact your administrator.",
	"errors.E0000124": "Could not create user. To create a user and expire their password immediately, a password must be specified",
	"errors.E0000125": "Could not create user. To create a user and expire their password immediately, \"activate\" must be true",
	"oform.next": "Next",
	"oform.verify": "Verify",
	"oform.send": "Send",
	"oform.back": "Back",
	"oform.save": "Save",
	"oform.cancel": "Cancel",
	"oform.edit": "Edit",
	"oform.previous": "Previous",
	"oform.errorbanner.title": "We found some errors. Please review the form and make corrections.",
	"oform.errormsg.title": "Please review the form to correct the following errors:",
	"oform.error.unexpected": "There was an unexpected internal error. Please try again.",
	"model.validation.field.blank": "The field cannot be left blank",
	"model.validation.field.ascii": "The field cannot contain Non-ASCII characters",
	"model.validation.field.wrong.type": "The field is of the wrong type",
	"model.validation.field.invalid": "The field has an invalid value",
	"model.validation.field.value.not.allowed": "The field value is not allowed",
	"model.validation.field.array.minItems": "The array does not have enough items",
	"model.validation.field.array.maxItems": "The array contains too many items",
	"model.validation.field.array.unique": "The array can only have unique values",
	"model.validation.field.too.long": "The field cannot exceed {0} characters",
	"model.validation.field.too.small": "The field cannot be less than {0} characters",
	"model.validation.field.string.minLength": "This field cannot be less than the minimum required characters",
	"model.validation.field.string.maxLength": "This field cannot exceed the maximum allowed characters",
	"model.validation.field.invalid.format.email": "This value is not a valid email address",
	"model.validation.field.invalid.format.uri": "This value is not a valid URI",
	"model.validation.field.invalid.format.ipv4": "This value is not a valid IPv4 address",
	"model.validation.field.invalid.format.hostname": "This value is not a valid hostname",
	"model.validation.field.username": "Please check your username",
	"factor.totpSoft.oktaVerify": "Okta Verify",
	"factor.totpSoft.googleAuthenticator": "Google Authenticator",
	"factor.totpSoft.description": "Enter single-use code from the mobile app.",
	"factor.totpHard.rsaSecurId": "RSA SecurID",
	"factor.totpHard.symantecVip": "Symantec VIP",
	"factor.totpHard.description": "Enter a single-use code from a hardware token.",
	"factor.totpHard.yubikey": "Yubikey",
	"factor.totpHard.yubikey.description": "Insert your Yubikey and tap it to get a verification code.",
	"factor.totpHard.yubikey.placeholder": "Click here, then tap your Yubikey",
	"factor.oktaVerifyPush": "Okta Verify",
	"factor.push.description": "Use a push notification sent to the mobile app.",
	"factor.duo": "Duo Security",
	"factor.duo.description": "Use Push Notification, SMS, or Voice call to authenticate.",
	"factor.sms": "SMS Authentication",
	"factor.sms.description": "Enter a single-use code sent to your mobile phone.",
	"factor.call": "Voice Call Authentication",
	"factor.call.description": "Use a phone to authenticate by following voice instructions.",
	"factor.securityQuestion": "Security Question",
	"factor.securityQuestion.description": "Use the answer to a security question to authenticate.",
	"factor.windowsHello": "Windows Hello",
	"factor.windowsHello.signin.description": "Sign in to Okta using Windows Hello.",
	"factor.u2f": "Security Key (U2F)",
	"factor.u2f.description": "Use a Universal 2nd Factor (U2F) security key to sign on to Okta.",
	"factor.email": "Email Authentication",
	"factor.password": "Password",
	"mfa.challenge.verify": "Verify",
	"mfa.challenge.answer.placeholder": "Answer",
	"mfa.challenge.answer.tooltip": "Answer",
	"mfa.challenge.answer.showAnswer": "Show",
	"mfa.challenge.answer.hideAnswer": "Hide",
	"mfa.challenge.enterCode.placeholder": "Enter Code",
	"mfa.challenge.enterCode.tooltip": "Enter Code",
	"mfa.challenge.password.placeholder": "Password",
	"mfa.backToFactors": "Back to factor list",
	"mfa.phoneNumber.placeholder": "Phone number",
	"mfa.phoneNumber.ext.placeholder": "Extension",
	"mfa.sendCode": "Send code",
	"mfa.sent": "Sent",
	"mfa.resendCode": "Re-send code",
	"mfa.call": "Call",
	"mfa.calling": "Calling",
	"mfa.redial": "Redial",
	"mfa.sendEmail": "Send email",
	"mfa.resendEmail": "Re-send email",
	"mfa.scanBarcode": "Scan barcode",
	"mfa.noAccessToEmail": "Can't access email",
	"password.reset": "Reset Password",
	"password.oldPassword.placeholder": "Old password",
	"password.oldPassword.tooltip": "Old password",
	"password.newPassword.placeholder": "New password",
	"password.newPassword.tooltip": "New password",
	"password.confirmPassword.placeholder": "Repeat password",
	"password.confirmPassword.tooltip": "Repeat password",
	"password.error.match": "New passwords must match",
	"recovery.sms.hint": "SMS can only be used if a mobile phone number has been configured.",
	"recovery.mobile.hint": "{0} can only be used if a mobile phone number has been configured.",
	"recovery.sms": "SMS",
	"recovery.call": "Voice Call",
	"recovery.smsOrCall": "SMS or Voice Call",
	"enroll.choices.title": "Set up multifactor authentication",
	"enroll.choices.description": "Your company requires multifactor authentication to add an additional layer of security when signing into your Okta account",
	"enroll.choices.optional": "You can configure any additional optional factor or click finish",
	"enroll.choices.list.setup": "Setup required",
	"enroll.choices.list.enrolled": "Enrolled factors",
	"enroll.choices.list.optional": "Additional optional factors",
	"enroll.choices.step": "{0} of {1}",
	"enroll.choices.setup": "Setup",
	"enroll.choices.submit.finish": "Finish",
	"enroll.choices.submit.configure": "Configure factor",
	"enroll.choices.submit.next": "Configure next factor",
	"enroll.securityQuestion.setup": "Setup secret question authentication",
	"security.disliked_food": "What is the food you least liked as a child?",
	"security.name_of_first_plush_toy": "What is the name of your first stuffed animal?",
	"security.first_award": "What did you earn your first medal or award for?",
	"security.favorite_security_question": "What is your favorite security question?",
	"security.favorite_toy": "What is the toy/stuffed animal you liked the most as a kid?",
	"security.first_computer_game": "What was the first computer game you played?",
	"security.favorite_movie_quote": "What is your favorite movie quote?",
	"security.first_sports_team_mascot": "What was the mascot of the first sports team you played on?",
	"security.first_music_purchase": "What music album or song did you first purchase?",
	"security.favorite_art_piece": "What is your favorite piece of art?",
	"security.grandmother_favorite_desert": "What was your grandmother's favorite dessert?",
	"security.first_thing_cooked": "What was the first thing you learned to cook?",
	"security.childhood_dream_job": "What was your dream job as a child?",
	"security.first_kiss_location": "Where did you have your first kiss?",
	"security.place_where_significant_other_was_met": "Where did you meet your spouse/significant other?",
	"security.favorite_vacation_location": "Where did you go for your favorite vacation?",
	"security.new_years_two_thousand": "Where were you on New Year's Eve in the year 2000?",
	"security.favorite_speaker_actor": "Who is your favorite speaker/orator?",
	"security.favorite_book_movie_character": "Who is your favorite book/movie character?",
	"security.favorite_sports_player": "Who is your favorite sports player?",
	"enroll.sms.setup": "Receive a code via SMS to authenticate",
	"enroll.sms.try_again": "The number you entered seems invalid. If the number is correct, please try again.",
	"enroll.call.setup": "Follow phone call instructions to authenticate",
	"enroll.onprem.username.placeholder": "Enter {0} username",
	"enroll.onprem.username.tooltip": "Enter {0} username",
	"enroll.onprem.passcode.placeholder": "Enter {0} passcode",
	"enroll.onprem.passcode.tooltip": "Enter {0} passcode",
	"enroll.symantecVip.subtitle": "Enter Credential ID and two consecutive generated codes",
	"enroll.symantecVip.credentialId.placeholder": "Enter credential ID",
	"enroll.symantecVip.credentialId.tooltip": "Enter credential ID",
	"enroll.symantecVip.passcode1.placeholder": "Security code 1",
	"enroll.symantecVip.passcode1.tooltip": "Security code 1",
	"enroll.symantecVip.passcode2.placeholder": "Security code 2",
	"enroll.symantecVip.passcode2.tooltip": "Security code 2",
	"enroll.yubikey.title": "Setup Yubikey",
	"enroll.yubikey.subtitle": "Insert your Yubikey into a USB port and tap it to generate a verification code",
	"enroll.totp.title": "Setup {0}",
	"enroll.totp.selectDevice": "Select your device type",
	"enroll.totp.downloadApp": "Download <a href=\"{0}\" class=\"inline-link\">{1} from the {2}</a> onto your mobile device.",
	"enroll.totp.installApp": "Install {0}",
	"enroll.duo.title": "Setup Duo Security",
	"enroll.windowsHello.title": "Enroll Windows Hello",
	"enroll.windowsHello.subtitle": "Click below to enroll Windows Hello as a second form of authentication",
	"enroll.windowsHello.subtitle.loading": "Please wait while Windows Hello is loading...",
	"enroll.windowsHello.save": "Enroll Windows Hello",
	"enroll.windowsHello.error.notWindows": "Windows Hello can only be used on Windows Edge with Windows 10. Contact your admin for assistance.",
	"enroll.windowsHello.error.notConfiguredHtml": "Windows Hello is not configured. Select the <b>Start</b> button, then select <b>Settings</b> &gt; <b>Accounts</b> &gt; <b>Sign-in</b> to configure Windows Hello.",
	"verify.windowsHello.subtitle": "Verify your identity with Windows Hello",
	"verify.windowsHello.subtitle.loading": "Please wait while Windows Hello is loading...",
	"verify.windowsHello.subtitle.signingIn": "Signing into Okta...",
	"verify.windowsHello.save": "Verify with Windows Hello",
	"verify.windowsHello.error.notFound": "Your Windows Hello enrollment does not match our records. Contact your administrator for assistance.",
	"verify.windowsHello.error.notFound.selectAnother": "Your Windows Hello enrollment does not match our records. Select another factor or contact your administrator for assistance.",
	"enroll.u2f.title": "Setup Security Key (U2F)",
	"enroll.u2f.save": "Register Security Key",
	"enroll.u2f.general1": "If using Firefox download and install the U2F browser extension.",
	"enroll.u2f.general2": "Make sure you have a Security Key. If already inserted, remove it now.<br>If you have a Bluetooth Security Key, turn on your computer's Bluetooth.",
	"enroll.u2f.general3": "Click the button below to register",
	"enroll.u2f.instructions": "Insert your Security Key into a USB port on this computer. If it has a button or gold disk, tap it.",
	"enroll.u2f.instructionsBluetooth": "If you are using a Bluetooth Security Key, press the button.",
	"u2f.error.notSupportedBrowser": "The Security Key is only supported for Chrome or Firefox browsers. Select another factor or contact your admin for assistance.",
	"u2f.error.notSupportedBrowser.oneFactor": "The Security Key is only supported for Chrome or Firefox browsers. Contact your admin for assistance.",
	"u2f.error.noFirefoxExtension": "<a target=\"_blank\" href=\"https://addons.mozilla.org/en-US/firefox/addon/u2f-support-add-on/\">Download</a> and install the Firefox U2F browser extension before proceeding. You may be required to restart your browser after installation.",
	"u2f.error.other": "An unknown error has occured. Try again or select another factor.",
	"u2f.error.other.oneFactor": "An unknown error has occured. Try again or contact your admin for assistance.",
	"u2f.error.badRequest": "There was an error with the U2F request. Try again or select another factor.",
	"u2f.error.badRequest.oneFactor": "There was an error with the U2F request. Try again or contact your admin for assistance.",
	"u2f.error.unsupported": "The security key is unsupported. Select another factor.",
	"u2f.error.unsupported.oneFactor": "The security key is unsupported. Contact your admin for assistance.",
	"u2f.error.timeout": "You have timed out of the authentication period. Please try again.",
	"verify.u2f.instructions": "Insert your Security Key. If it has a button or gold disk, tap it.",
	"verify.u2f.instructionsBluetooth": "If you are using a Bluetooth Security Key, turn on your computer's Bluetooth and press the button.",
	"verify.u2f.retry": "Retry",
	"enroll.totp.enterCode": "Enter code displayed from the application",
	"enroll.totp.setupApp": "Launch {0} application on your mobile device and select Add an account.",
	"enroll.totp.setupGoogleAuthApp": "Launch {0}, tap the \"+\" icon, then select \"Scan barcode\".",
	"enroll.totp.cannotScan": "Can't scan?",
	"enroll.totp.refreshBarcode": "Refresh code",
	"enroll.totp.cannotScanBarcode": "Can't scan barcode?",
	"enroll.totp.manualSetupInstructions": "To set up manually enter your Okta Account username and then input the following in the Secret Key Field",
	"enroll.totp.sharedSecretInstructions": "Enter your Okta Account username and enter the following in the Secret Key Field",
	"enroll.totp.sendSms": "Send activation link via SMS",
	"enroll.totp.sendEmail": "Send activation link via email",
	"enroll.totp.setupManually": "Setup manually without push notification",
	"enroll.totp.enrollViaEmail.title": "Activation email sent!",
	"enroll.totp.enrollViaEmail.msg": "Open the email from your mobile device.",
	"enroll.totp.enrollViaSms.title": "SMS sent!",
	"enroll.totp.enrollViaSms.msg": "View the SMS on your mobile device.",
	"recoveryChallenge.sms.title": "Enter verification code sent via SMS",
	"recoveryChallenge.call.title": "Enter verification code received via Voice Call",
	"mfa.factors.dropdown.title": "Select an authentication factor",
	"mfa.duoSecurity.push": "Push — {0}",
	"mfa.duoSecurity.sms": "SMS — {0}",
	"mfa.duoSecurity.call": "Call — {0}",
	"mfa.challenge.title": "Enter your {0} passcode",
	"mfa.challenge.orEnterCode": "Or enter code",
	"oktaverify.send": "Send Push",
	"oktaverify.resend": "Re-send Push",
	"oktaverify.sent": "Push sent!",
	"oktaverify.rejected": "You have chosen to reject this login.",
	"oktaverify.timeout": "Your push notification has expired.",
	"oktaverify.warning": "Haven't received a push notification yet? Try opening the Okta Verify App on your phone.",
	"primaryauth.title": "Sign In",
	"primaryauth.username.placeholder": "Username",
	"primaryauth.username.tooltip": "Username",
	"primaryauth.password.placeholder": "Password",
	"primaryauth.password.tooltip": "Password",
	"primaryauth.submit": "Sign In",
	"primaryauth.newUser.tooltip": "This is the first time you are connecting to {0} from this browser",
	"primaryauth.newUser.tooltip.close": "Close",
	"idpDiscovery.email.placeholder": "Email",
	"password.forgot.email.or.username.placeholder": "Email or Username",
	"password.forgot.email.or.username.tooltip": "Email or Username",
	"password.forgot.sendText": "Reset via SMS",
	"password.forgot.sendEmail": "Reset via Email",
	"password.forgot.call": "Reset via Voice Call",
	"password.forgot.emailSent.title": "Email sent!",
	"password.forgot.emailSent.desc": "Email has been sent to {0} with instructions on resetting your password.",
	"password.forgot.question.title": "Answer Forgotten Password Challenge",
	"password.forgot.question.submit": "Reset Password",
	"password.forgot.code.notReceived": "Didn't receive a code? Reset via email",
	"password.forgot.noFactorsEnabled": "No password reset options available. Please contact your administrator.",
	"password.reset.title": "Reset your Okta password",
	"password.complexity.requirements": "Password requirements: {0}.",
	"password.complexity.history": "Your password cannot be any of your last {0} passwords.",
	"password.complexity.minAgeMinutes": "At least {0} minute(s) must have elapsed since you last changed your password.",
	"password.complexity.minAgeHours": "At least {0} hour(s) must have elapsed since you last changed your password.",
	"password.complexity.minAgeDays": "At least {0} day(s) must have elapsed since you last changed your password.",
	"password.complexity.length": "at least {0} characters",
	"password.complexity.list.element": ", {0}",
	"password.complexity.lowercase": "a lowercase letter",
	"password.complexity.uppercase": "an uppercase letter",
	"password.complexity.number": "a number",
	"password.complexity.symbol": "a symbol",
	"password.complexity.no_username": "no parts of your username",
	"password.complexity.no_first_name": "does not include your first name",
	"password.complexity.no_last_name": "does not include your last name",
	"password.expired.submit": "Change Password",
	"password.expired.title": "Your Okta password has expired",
	"password.expiring.later": "Remind me later",
	"password.expiring.title": "Your password will expire in {0} days",
	"password.expiring.today": "Your password will expire later today",
	"password.expiring.soon": "Your password is expiring soon",
	"password.expiring.subtitle": "When password expires you may be locked out of Okta Mobile, mobile email, and other services.",
	"password.expired.custom.submit": "Go to {0}",
	"password.expired.custom.subtitle": "This password is set on another website. Click the button below to go there and set a new password.",
	"account.unlock.title": "Unlock account",
	"account.unlock.email.or.username.placeholder": "Email or username",
	"account.unlock.email.or.username.tooltip": "Email or username",
	"account.unlock.sendText": "Send SMS",
	"account.unlock.voiceCall": "Voice Call",
	"account.unlock.sendEmail": "Send Email",
	"account.unlock.emailSent.title": "Email sent!",
	"account.unlock.emailSent.desc": "Email has been sent to {0} with instructions on unlocking your account.",
	"account.unlock.question.title": "Answer Unlock Account Challenge",
	"account.unlock.question.submit": "Unlock Account",
	"account.unlock.unlocked.title": "Account successfully unlocked!",
	"account.unlock.unlocked.desc": "You can log in using your existing username and password.",
	"account.unlock.code.notReceived": "Didn't receive a code? Unlock via email",
	"account.unlock.noFactorsEnabled": "No unlock options available. Please contact your administrator.",
	"contact.support": "If you didn't provide a secondary email address or don't have access to email, please contact your administrator at {0}",
	"socialauth.divider.text": "OR",
	"socialauth.facebook.label": "Sign in with Facebook",
	"socialauth.google.label": "Sign in with Google",
	"socialauth.linkedin.label": "Sign in with LinkedIn",
	"socialauth.microsoft.label": "Sign in with Microsoft",
	"socialauth.popup.title": "External Identity Provider User Authentication",
	"authbutton.divider.text": "or",
	"registration.signup.label": "Don't have an account?",
	"registration.signup.text": "Sign up",
	"registration.complete.title": "Verification email sent",
	"registration.complete.desc": "We just sent a verification email to {0}. Please check your email and verify your account to continue.",
	"registration.form.title": "Create Account",
	"registration.form.submit": "Register",
	"registration.passwordComplexity.minLength": "At least {0} character(s)",
	"registration.passwordComplexity.minLower": "At least {0} lowercase letter(s)",
	"registration.passwordComplexity.minUpper": "At least {0} uppercase letter(s)",
	"registration.passwordComplexity.minNumber": "At least {0} number(s)",
	"registration.passwordComplexity.minSymbol": "At least {0} symbol(s)",
	"registration.passwordComplexity.excludeUsername": "Does not contain part of username",
	"registration.passwordComplexity.excludeAttribute": "Does not contain '{0}'",
	"registration.required.fields.label": "* indicates required field",
	"registration.default.callbackhook.error": "We could not process your registration at this time. Please try again later.",
	"registration.error.userName.invalidEmail": "Invalid email address",
	"registration.error.password.passwordRequirementsNotMet": "Password requirements were not met",
	"registration.error.userName.notUniqueWithinOrg": "An account with that email already exists",
	"piv.card": "PIV Card",
	"piv.card.insert": "Please insert your PIV card and select the user certificate.",
	"piv.card.error": "Certificate authentication failed. Contact your admin.",
	"piv.card.error.empty": "No certificate selected. Choose a certificate and try again.",
	"piv.card.error.invalid": "Certificate validation failed. Choose another certificate and try again.",
	"unsupported.oneDrive.title": "Your OneDrive version is not supported",
	"unsupported.oneDrive.desc": "Upgrade now by installing the OneDrive for Business Next Generation Sync Client to login to Okta",
	"unsupported.oneDrive.action": "Learn how to upgrade",
	"unsupported.cookies.title": "Cookies are required",
	"unsupported.cookies.desc": "Cookies are disabled on your browser. Please enable Cookies and refresh this page.",
	"unsupported.cookies.action": "Refresh ",
	"deviceTrust.sso.text": "Sign in to access company resources",
	"deviceTrust.sso.subtitle": "Okta Mobile will check that your device is secure and make it easy to sign in.",
	"deviceTrust.sso.button": "Sign in with Okta Mobile",
	"deviceTrust.sso.expire.title": "Oops let's get you back on track",
	"deviceTrust.sso.expire.subtitle": "Unfortunately the steps required to sign in took longer than expected and your attempt timed out.",
	"deviceTrust.sso.expire.button": "Sign in using Okta Mobile",
	"deviceTrust.universalLink.fallback.getOktaMobile.title": "Get Okta Mobile",
	"deviceTrust.universalLink.fallback.getOktaMobile.subtitle": "Go to the {0}AppStore{1}, {0}search{1} for {0}Okta Mobile{1} and tap on {0}GET{1} Okta Mobile. Once installed, sign in to Okta Mobile and follow the instructions to secure your device.",
	"consent.required.text": "<b>{0}</b> would like to do the following on your behalf, <b>{1}</b>:",
	"consent.required.headline": "<b>{0}</b> is requesting permissions to:",
	"consent.required.description": "By clicking Allow Access, you allow this app access to the actions listed above.",
	"consent.required.termsOfService": "Terms of Service",
	"consent.required.privacyPolicy": "Privacy Policy",
	"consent.required.consentButton": "Allow Access",
	"consent.required.cancelButton": "Don't Allow",
	"cert.authentication.title": "Certificate authentication",
	"consent.required.label": "<b>{0}</b> wants to access your account (<b>{1}</b>) in order to:",
	"password.forgot.sms.notReceived": "Didn't receive an SMS? Reset via email",
	"account.unlock.sms.notReceived": "Didn't receive an SMS? Unlock via email"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./packages/@okta/i18n/dist/json/login.json
 ** module id = 345
 ** module chunks = 0
 **/